<script setup>
import { IconChevronRight } from '@tabler/icons-vue';

const open = defineModel('isOpen', {
    type: Boolean,
    default: false,
});

defineOptions({
    name: 'PageSectionCollapsible',
});
</script>

<template>
    <div class="w-full p-2 rounded-lg bg-gray-100" :open="open" @toggle="open = $event.target.open">
        <details class="" :open="open" @toggle="open = $event.target.open">
            <summary
                class="flex items-center w-full gap-2 rounded-lg bg-gray-200 px-4 py-2 text-left text-sm font-medium hover:bg-gray-300 cursor-pointer"
            >
                <div>
                    <IconChevronRight
                        :class="open ? 'text-gray-600 rotate-90' : 'text-gray-500'"
                        class="ml-auto h-5 w-5 group-hover:text-gray-500 group-focus:text-gray-500 transform transition-transform ease-in-out duration-150"
                    />
                </div>
                <div>
                    <h3 class="text-base font-semibold leading-7 text-gray-900"><slot name="title" /></h3>
                    <p class="mt-1 text-sm leading-6 text-gray-500" v-if="$slots.subtitle">
                        <slot name="subtitle" />
                    </p>
                </div>
            </summary>

            <div class="mt-3">
                <slot />
            </div>
        </details>
        <div v-if="!open">
            <slot name="closed" />
        </div>
    </div>
</template>
<style scoped>
details summary::-webkit-details-marker,
details summary::marker {
    display: none;
    content: '';
}
</style>
